import { z } from "zod";

const _paginationMetaSchema = z.object({
  total: z.number(),
  page: z.number(),
  limit: z.number(),
  totalPages: z.number(),
});

export function paginatedResponseSchema<ItemSchema extends z.ZodTypeAny>(
  itemSchema: ItemSchema,
) {
  return _paginationMetaSchema.extend({
    items: z.array(itemSchema).readonly(),
  });
}

export type Paginated<T> = Readonly<z.infer<typeof _paginationMetaSchema>> & {
  readonly items: readonly T[];
};
